module.exports = __webpack_public_path__ + "static/media/approval-orange.22246ece.svg";